module.exports = __webpack_public_path__ + "img/gear.8c0a56ac.png";